import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  lessonApi,
  tPromiseFromFunctionResolved,
  ILessonGameplays,
  tSharedAppDispatch
} from 'common/modules/ReactShared';
import { actions as rewardNotificationsActions } from '../../member/rewardNotifications/slice';

type tGameplay = ILessonGameplays | null;
const initialGameplays: tGameplay = null;

const createLessonGameplay = createAsyncThunk<
  tPromiseFromFunctionResolved<typeof lessonApi.fetchCreateGameplay>,
  number
>('gameplays/fetchGameplayCreate_request', async (lessonId) => {
  const gameplay = await lessonApi.fetchCreateGameplay(lessonId);
  return gameplay;
});

const playStudentWord = createAsyncThunk<void, { wordId: number; solved: boolean }>(
  'gameplays/fetchPlayStudentWord_request',
  async ({ wordId, solved }) => {
    await lessonApi.fetchPlayStudentWord(wordId, solved);
  }
);

const finishLessonGameplay = createAsyncThunk<
  void,
  {
    lessonId: number;
    gameplayId: number;
    params: Parameters<typeof lessonApi.fetchFinishGameplay>[2];
  },
  { dispatch: tSharedAppDispatch }
>(
  'gameplays/fetchFinishGameplay_request',
  async ({ lessonId, gameplayId, params }, { dispatch }) => {
    await lessonApi.fetchFinishGameplay(lessonId, gameplayId, params);
    // Each word played may have crossed a badge threshold server-side; the
    // game's end is the moment to mark the celebration queue stale.
    dispatch(rewardNotificationsActions.invalidate());
  }
);

const gameplaysSlice = createSlice({
  name: 'gameplays',
  initialState: initialGameplays as tGameplay,
  reducers: {
    drop: () => initialGameplays
  },
  extraReducers: (builder) => {
    builder.addCase(createLessonGameplay.fulfilled, (_, action) => {
      return action.payload;
    });
  }
});

const { reducer, actions } = gameplaysSlice;
export const gameplaysActions = {
  createLessonGameplay,
  playStudentWord,
  finishLessonGameplay,
  ...actions
};
export default reducer;
